/**
 * DEV-972. Строки для меню вложений мессенджера и пикера «Отправить объект (ЖК)».
 * Подмешиваются в секцию `messenger` базовых локалей через deepMerge (locales/index.ts).
 */
export const messengerShareMessages = {
  ru: {
    messenger: {
      attach: {
        menu: 'Прикрепить',
        file: 'Файл',
        object: 'Объект',
      },
      sharePicker: {
        title: 'Отправить объект',
        searchPlaceholder: 'Поиск по названию ЖК...',
        filters: {
          city: 'Город',
          rooms: 'Комнатность',
          price: 'Цена, ₫',
          type: 'Тип',
        },
        filtersToggle: 'Фильтры',
        reset: 'Сбросить',
        retry: 'Повторить',
        priceFrom: 'от {price}',
        found: 'Найдено {count}',
        selected: 'Выбрано {selected} из {total}',
        submit: 'Отправить {count}',
        empty: 'Объекты не найдены',
        error: 'Не удалось загрузить объекты',
        skipped: 'Не отправлены (нет ссылки): {names}',
      },
    },
  },
  en: {
    messenger: {
      attach: {
        menu: 'Attach',
        file: 'File',
        object: 'Property',
      },
      sharePicker: {
        title: 'Send a property',
        searchPlaceholder: 'Search by complex name...',
        filters: {
          city: 'City',
          rooms: 'Rooms',
          price: 'Price',
          type: 'Type',
        },
        filtersToggle: 'Filters',
        reset: 'Reset',
        retry: 'Retry',
        priceFrom: 'from {price}',
        found: 'Found {count}',
        selected: 'Selected {selected} of {total}',
        submit: 'Send {count}',
        empty: 'No properties found',
        error: 'Failed to load properties',
        skipped: 'Not sent (no link): {names}',
      },
    },
  },
  vn: {
    messenger: {
      attach: {
        menu: 'Đính kèm',
        file: 'Tệp',
        object: 'Dự án',
      },
      sharePicker: {
        title: 'Gửi dự án',
        searchPlaceholder: 'Tìm theo tên dự án...',
        filters: {
          city: 'Thành phố',
          rooms: 'Số phòng',
          price: 'Giá',
          type: 'Loại',
        },
        filtersToggle: 'Bộ lọc',
        reset: 'Đặt lại',
        retry: 'Thử lại',
        priceFrom: 'từ {price}',
        found: 'Tìm thấy {count}',
        selected: 'Đã chọn {selected}/{total}',
        submit: 'Gửi {count}',
        empty: 'Không tìm thấy dự án',
        error: 'Không tải được danh sách dự án',
        skipped: 'Chưa gửi (thiếu liên kết): {names}',
      },
    },
  },
}
